import { jsx as _jsx, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
import { useState } from 'react';
import { Button, CssLoader, Modal } from '@cimpress/react-components';
import { getI18nInstance } from '../locales/i18n';
import { TransmissionsList } from './transmissionsList';
import { ErrorBoundary } from '../errorBoundary';
export const SIViewer = props => {
    const [showModal, setShowModal] = useState(false);
    const t = getI18nInstance().getFixedT(props.language);
    const closeModal = () => {
        setShowModal(false);
    };
    return (_jsxs("div", { children: [_jsx("a", Object.assign({ role: 'button', onClick: () => {
                    setShowModal(true);
                } }, { children: props.placeHolder || t('siViewer.name') })), _jsx(Modal, Object.assign({ status: 'info', show: showModal, style: { width: '80%' }, onRequestHide: closeModal, title: t('siViewer.modal.title'), closeButton: false, size: 'lg', footer: (_jsx(Button, Object.assign({ variant: 'default', onClick: closeModal }, { children: t('siViewer.modal.close') }))) }, { children: _jsx(ErrorBoundary, Object.assign({ t: t }, { children: _jsx(TransmissionsList, { accessToken: props.accessToken, itemDetails: props.itemDetails, env: props.env, displayTimezone: props.displayTimezone, language: props.language }) })) }))] }));
};
export const CSSLoaderWrappedSIViewer = props => {
    return (_jsx(CssLoader, { children: _jsx(SIViewer, Object.assign({}, props)) }));
};
